// import libs
import React, { lazy, Suspense } from 'react';
import { Navigate, Routes, Route } from 'react-router';
import LinearProgress from '@mui/material/LinearProgress';

import Layout from '../Layout';
import Home from '../Modules/Home';
const Login = lazy(() => import('../Modules/Login'));
const SignUp = lazy(() => import('../Modules/Signup'));
const ForgotPassword = lazy(() => import('../Modules/ForgotPassword'));
const ResetPassword = lazy(() => import('../Modules/ResetPassword'));
const Invite = lazy(() => import('../Modules/Invite'));

const AppRoutes = () => (
  <Suspense
    fallback={
      <div
        style={{
          position: 'fixed',
          width: '100%',
          height: '100vh',
          marginTop: '49vh',
        }}
      >
        <LinearProgress color="secondary" />
      </div>
    }
  >
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate replace to="/home" />} />
        <Route path="/home/*" element={<Home />}></Route>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/resetpassword/token/:token" element={<ResetPassword />} />
        <Route path="/invite/token/:token" element={<Invite />} />
      </Routes>
    </Layout>
  </Suspense>
);

export default AppRoutes;
